import { useContext, useEffect, useCallback } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

export function useBlocker(blocker, when = true) {
  const { navigator } = useContext(NavigationContext);

  const handleNavigation = useCallback(
    (push, replace, args, isReplace = false) => {
      const action = isReplace 
        ? () => replace.apply(navigator, args)
        : () => push.apply(navigator, args);
      const location = args[0];

      blocker({
        location: typeof location === "string" ? { pathname: location } : location,
        retry: () => {
          navigator.push = push;
          navigator.replace = replace;
          action();
        },
        abort: () => {
          // Navigation aborted
        }
      });
    },
    [navigator, blocker]
  );

  useEffect(() => {
    if (!when) return;

    const push = navigator.push;
    const replace = navigator.replace;

    navigator.push = (...args) => {
      handleNavigation(push, replace, args, false);
    };

    navigator.replace = (...args) => {
      handleNavigation(push, replace, args, true);
    };

    return () => {
      navigator.push = push;
      navigator.replace = replace;
    };
  }, [navigator, when, handleNavigation]);
}
